import isArray from 'lodash/isArray'
import keys from 'lodash/keys'
import camelCase from 'lodash/camelCase'
import QueryString from './query-string'

/**
 * @desc shorten a collection of string values
 *
 * @param {array|object} coll collection of values to shorten
 * @param {number} cutoff threshold to shorten strings
 *
 * @returns {object|array} same as input
 */
const shortenLongValues = (coll, cutoff) => {
  if (isArray(coll)) {
    return coll.map((str) => {
      if (!str || typeof str !== 'string') return str
      const short = str.substr(0, cutoff)
      const shouldShorten = str.length && short.length < str.length
      return shouldShorten ? `${short}...` : str
    })
  }

  return keys(coll).reduce((acc, key) => {
    const value = coll[key] || ''
    const short = value.substr(0, cutoff)
    const shouldShorten = value.length && short.length < value.length
    acc[key] = shouldShorten ? `${short}...` : value
    return acc
  }, {})
}

const removeSpecialChars = (str = '') => str.replace(/[^a-z]/gi, '')

/**
* @desc highlight a specific word in a given sentence
* @param input - sentence where to look for the word (or) characters
* @param charsToHightlight - the word (or) characters to find & hightlight
* @param hightlightClassName - the classname to highlight the word (or) characters if found
*/
const highlightKeyword = (input = '', charsToHightlight = '', hightlightClassName = '') => {
  if (input.trim() === '' || charsToHightlight.trim() === '') {
    return null
  }

  return input.replace(
    new RegExp(`(?![^&;]+;)(?!<[^<>]*)(${charsToHightlight})(?![^<>]*>)(?![^&;]+;)`, 'gi'),
    `<span class=${hightlightClassName}>$1</span>`,
  )
}

function beautifyForSEO(str) {
  return str.trim()
    .toLowerCase()
    .replace(/(<([^>]+)>)/ig, '')
    .replace(/[^a-z0-9_. ]/g, '')
    .replace(/_/g, '-')
    .replace(/[ ]/g, '-')
    .replace(/-+/g, '-')
    .replace('pound', 'pound-')
}

const escapeHTMLMap = {
  '<': '&lt;',
  '>': '&gt;',
}
const escapeHTML = (str = '') => {
  const repl = s => escapeHTMLMap[s]
  return str.replace(/[<>]/g, repl)
}
const escapeHTMLFromSearchURL = (url = '') => {
  const urlArray = url.split('/')
  const decodedSearchTerm = decodeURIComponent(urlArray[4])
  if (!Object.keys(escapeHTMLMap).some(c => decodedSearchTerm.includes(c))) {
    return url
  }
  urlArray[4] = encodeURIComponent(escapeHTML(decodedSearchTerm))
  return urlArray.join('/')
}

/**
* @desc make phrases sentence case (not applicable to sentences)
* @param str - the phrase that needs to be in sentence case
*/
const makeSentenceCase = (str) => {
  if (typeof str !== 'string') return str
  return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase()
}

/**
* @desc returns plural or singular noun
* @param plural - plural form of noun
* @param singular - singular form of noun
* @param count - count of entity
*/
const pluralizeWord = (count, singular, plural) => (count === 1 ? singular : plural)

function toCamelCase(str) {
  if (typeof str !== 'string') {
    return str
  }
  return camelCase(str)
}

function camelCaseKeys(obj) {
  const keyNames = keys(obj)

  if (!keyNames.length) return obj

  return keyNames.reduce((acc, key) => {
    const value = obj[key]
    const camelCased = toCamelCase(key)
    acc[camelCased] = value
    return acc
  }, {})
}


export {
  QueryString,
  shortenLongValues,
  removeSpecialChars,
  highlightKeyword,
  beautifyForSEO,
  escapeHTML,
  escapeHTMLFromSearchURL,
  makeSentenceCase,
  pluralizeWord,
  toCamelCase,
  camelCaseKeys,
}



// WEBPACK FOOTER //
// ./shared/util/string/index.js